<div
  class="mb-4 flex flex-col gap-2 rounded-lg border border-gray-200 bg-white p-6 filters-shadow"
  (click)="onContainerClick($event)">
  <div class="border-border grid grid-cols-3 gap-6 border-b pt-4 pb-6">
    <app-filter-input
      [label]="isArabic() ? 'اسم الخط' : 'Route Name'"
      [placeholder]="isArabic() ? 'ابحث باسم الخط...' : 'Search by route name'"
      type="text"
      [(value)]="routeName"></app-filter-input>

    <app-filter-select-component
      [label]="isArabic() ? 'الحالة' : 'Status'"
      [defaultOption]="isArabic() ? 'الكل' : 'All'"
      [options]="activeOptions()"
      [(value)]="isActive"></app-filter-select-component>

    <app-filter-multi-select
      [label]="{ titleAr: 'المحافظة', titleEn: 'Governorate' }"
      [placeholder]="{ titleAr: 'اختر المحافظة', titleEn: 'Choose Governorate' }"
      [items]="governorateOptions()"
      [(selectedIds)]="selectedGovernorateIds"
      [showDropdown]="showGovernorateDropdown()"
      (toggleDropdown)="toggleGovernorateDropdown()"
      (selectionChange)="onGovernorateChange($event)"></app-filter-multi-select>

    <app-filter-select-component
      [label]="isArabic() ? 'المدينة' : 'City'"
      [defaultOption]="isArabic() ? 'كل المدن' : 'All Cities'"
      [options]="cityOptions()"
      [(value)]="selectedCityId"
      (valueChange)="onCityChange($event)"></app-filter-select-component>

    <app-filter-select-component
      [label]="isArabic() ? 'المنطقة' : 'Region'"
      [defaultOption]="isArabic() ? 'كل المناطق' : 'All Regions'"
      [options]="regionOptions()"
      [(value)]="selectedRegionId"></app-filter-select-component>

    <app-filter-multi-select
      [label]="{ titleAr: 'عدد الفترات', titleEn: 'Intervals Count' }"
      [placeholder]="{ titleAr: 'اختر الفترات', titleEn: 'Choose Intervals' }"
      [items]="intervalOptions()"
      [(selectedIds)]="selectedIntervalIds"
      [showDropdown]="showIntervalDropdown()"
      (toggleDropdown)="toggleIntervalDropdown()"
      (selectionChange)="selectedIntervalIds.set($event)"></app-filter-multi-select>

    <app-filter-date-component
      [label]="isArabic() ? 'تاريخ الإنشاء (من)' : 'Creation Date From'"
      [value]="createdOnFrom()"
      (valueChange)="createdOnFrom.set($event)"
      [isInvalid]="createdDateInvalid()"></app-filter-date-component>

    <app-filter-date-component
      [label]="isArabic() ? 'تاريخ الإنشاء (إلى)' : 'Creation Date To'"
      [value]="createdOnTo()"
      (valueChange)="createdOnTo.set($event)"
      [isInvalid]="createdDateInvalid()"></app-filter-date-component>
    <div></div>

    <app-filter-date-component
      [label]="isArabic() ? 'آخر تعديل (من)' : 'Last Modified From'"
      [value]="lastModifiedOnFrom()"
      (valueChange)="lastModifiedOnFrom.set($event)"
      [isInvalid]="lastModifiedDateInvalid()"></app-filter-date-component>

    <app-filter-date-component
      [label]="isArabic() ? 'آخر تعديل (إلى)' : 'Last Modified To'"
      [value]="lastModifiedOnTo()"
      (valueChange)="lastModifiedOnTo.set($event)"
      [isInvalid]="lastModifiedDateInvalid()"></app-filter-date-component>

    <div></div>
    <div></div>
  </div>

  <div class="flex justify-between pt-4">
    <app-filter-sorting-component
      [orderBy]="filters().orderBy!"
      (orderByChange)="filters().orderBy = $event"
      [orderDir]="filters().orderDir!"
      [sortOptions]="sortOptions()"
      (toggleOrder)="onToggleSortOrder()"></app-filter-sorting-component>

    <div class="flex items-end justify-end gap-3">
      <button
        (click)="onResetFilters()"
        class="border-primary text-primary hover-bg-primary-10 rounded-[6px] border px-5 py-1.5 text-[13px] font-[500] hover:cursor-pointer">
        <span i18n="@@adminProductsResetButton">Clear</span>
      </button>
      <button
        (click)="onApplyFilters()"
        class="bg-primary hover-bg-primary-hover rounded-[6px] px-5 py-1.5 text-[13px] font-[500] text-white hover:cursor-pointer">
        <span i18n="@@adminProductsApplyButton">Apply</span>
      </button>
    </div>
  </div>
</div>
